export const API_URL =
    process.env.NODE_ENV === 'development' ?
        window.location.protocol + "//" + window.location.hostname + ":" + process.env.REACT_APP_PORT_API + "/"
        :
        window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/api/";